import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientInterface, DocumentType } from '../data';
import { ClientProvider } from '../providers/client.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetClientByDocumentUseCaseParams {
    docType: DocumentType;
    docId: string;
}

@Injectable()
export class GetClientByDocumentUseCase
    implements UseCaseWithParam<GetClientByDocumentUseCaseParams, Observable<Transaction<ClientInterface>>>
{
    constructor(private clientProvider: ClientProvider) {}

    bind(params: GetClientByDocumentUseCaseParams): Observable<Transaction<ClientInterface>> {
        return this.clientProvider.findByDocument(params.docType, params.docId).pipe(
            map((transaction) =>
                transaction.map(
                    (client) => Transaction.success(cloneDeep(client)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
